/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { Disasters } from '../../models/disasters';

export interface GetDisasters$Params {}

export function getDisasters(
   http: HttpClient,
   rootUrl: string,
   params?: GetDisasters$Params,
   context?: HttpContext
): Observable<StrictHttpResponse<Disasters>> {
   const rb = new RequestBuilder(rootUrl, getDisasters.PATH, 'get');
   if (params) {
   }

   return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
         return r as StrictHttpResponse<Disasters>;
      })
   );
}

getDisasters.PATH = '/api/alert/disaster/list';
